import { adminPaymentGatewaysConstants } from '../_constants';

const initialState = {
  paymentGateways: [],
  paymentMethods: [],
  paymentMethodGateways: [],
  chargeStatus: [],
  chargeStatusPaymentGateways: [],
  isLoadingPaymentGateways: false,
  isLoadingPaymentMethods: false,
  isLoadingPaymentMethodGateways: false,
  isLoadingChargeStatus: false,
  isLoadingChargeStatusPaymentGateways: false,
  error: null,
};

export function adminPaymentGateways(state = initialState, action) {
  switch (action.type) {
    case adminPaymentGatewaysConstants.PAYMENT_GATEWAYS_FETCH_REQUEST:
      return {
        ...state,
        isLoadingPaymentGateways: true,
        error: null,
      };
    case adminPaymentGatewaysConstants.PAYMENT_GATEWAYS_FETCH_SUCCESS:
      return {
        ...state,
        paymentGateways: action.payload.paymentGateways,
        isLoadingPaymentGateways: false,
        error: null,
      };
    case adminPaymentGatewaysConstants.PAYMENT_GATEWAYS_FETCH_FAILURE:
      return {
        ...state,
        isLoadingPaymentGateways: false,
        error: action.payload.error,
      };

    case adminPaymentGatewaysConstants.PAYMENT_GATEWAY_CREATE_REQUEST:
      return {
        ...state,
        isLoadingPaymentGateways: true,
        error: null,
      };
    case adminPaymentGatewaysConstants.PAYMENT_GATEWAY_CREATE_SUCCESS:
      return {
        ...state,
        paymentGateways: [...state.paymentGateways, action.payload.paymentGateway],
        isLoadingPaymentGateways: false,
        error: null,
      };
    case adminPaymentGatewaysConstants.PAYMENT_GATEWAY_CREATE_FAILURE:
      return {
        ...state,
        isLoadingPaymentGateways: false,
        error: action.payload.error,
      };

    case adminPaymentGatewaysConstants.PAYMENT_GATEWAY_UPDATE_REQUEST:
      return {
        ...state,
        isLoadingPaymentGateways: true,
        error: null,
      };
    case adminPaymentGatewaysConstants.PAYMENT_GATEWAY_UPDATE_SUCCESS:
      return {
        ...state,
        paymentGateways: (state.paymentGateways || []).map(gateway =>
          gateway.id === action.payload.paymentGateway.id
            ? action.payload.paymentGateway
            : gateway,
        ),
        isLoadingPaymentGateways: false,
        error: null,
      };
    case adminPaymentGatewaysConstants.PAYMENT_GATEWAY_UPDATE_FAILURE:
      return {
        ...state,
        isLoadingPaymentGateways: false,
        error: action.payload.error,
      };

    case adminPaymentGatewaysConstants.PAYMENT_GATEWAY_DELETE_REQUEST:
      return {
        ...state,
        isLoadingPaymentGateways: true,
        error: null,
      };
    case adminPaymentGatewaysConstants.PAYMENT_GATEWAY_DELETE_SUCCESS:
      return {
        ...state,
        paymentGateways: state.paymentGateways.filter(
          gateway => gateway.id !== action.payload.id,
        ),
        isLoadingPaymentGateways: false,
        error: null,
      };
    case adminPaymentGatewaysConstants.PAYMENT_GATEWAY_DELETE_FAILURE:
      return {
        ...state,
        isLoadingPaymentGateways: false,
        error: action.payload.error,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHOD_GATEWAY_FETCH_REQUEST:
      return {
        ...state,
        isLoadingPaymentMethodGateways: true,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHOD_GATEWAY_FETCH_SUCCESS:
      return {
        ...state,
        paymentMethodGateways: action.paymentMethodGateways,
        isLoadingPaymentMethodGateways: false,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHOD_GATEWAY_FETCH_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoadingPaymentMethodGateways: false,
      };

    case adminPaymentGatewaysConstants.PAYMENT_METHOD_GATEWAY_CREATE_REQUEST:
      return {
        ...state,
        isLoadingPaymentMethodGateways: true,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHOD_GATEWAY_CREATE_SUCCESS:
      return {
        ...state,
        paymentMethodGateways: [
          ...(state.paymentMethodGateways || []),
          action.paymentMethodGateway,
        ],
        isLoadingPaymentMethodGateways: false,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHOD_GATEWAY_CREATE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoadingPaymentMethodGateways: false,
      };

    case adminPaymentGatewaysConstants.PAYMENT_METHOD_GATEWAY_UPDATE_REQUEST:
      return {
        ...state,
        isLoadingPaymentMethodGateways: true,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHOD_GATEWAY_UPDATE_SUCCESS:
      return {
        ...state,
        paymentMethodGateways: state.paymentMethodGateways.map(association =>
          association.id === action.paymentMethodGateway.id
            ? action.paymentMethodGateway
            : association,
        ),
        isLoadingPaymentMethodGateways: false,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHOD_GATEWAY_UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoadingPaymentMethodGateways: false,
      };

    case adminPaymentGatewaysConstants.PAYMENT_METHOD_GATEWAY_DELETE_REQUEST:
      return {
        ...state,
        isLoadingPaymentMethodGateways: true,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHOD_GATEWAY_DELETE_SUCCESS:
      return {
        ...state,
        paymentMethodGateways: state.paymentMethodGateways.filter(
          association => association.id !== action.id,
        ),
        isLoadingPaymentMethodGateways: false,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHOD_GATEWAY_DELETE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoadingPaymentMethodGateways: false,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHODS_FETCH_REQUEST:
      return {
        ...state,
        isLoadingPaymentMethods: true,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHODS_FETCH_SUCCESS:
      return {
        ...state,
        paymentMethods: action.paymentMethods,
        isLoadingPaymentMethods: false,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHODS_FETCH_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoadingPaymentMethods: false,
      };

    case adminPaymentGatewaysConstants.PAYMENT_METHOD_CREATE_REQUEST:
      return {
        ...state,
        isLoadingPaymentMethods: true,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHOD_CREATE_SUCCESS:
      return {
        ...state,
        paymentMethods: [...(state.paymentMethods || []), action.paymentMethod],
        isLoadingPaymentMethods: false,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHOD_CREATE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoadingPaymentMethods: false,
      };

    case adminPaymentGatewaysConstants.PAYMENT_METHOD_UPDATE_REQUEST:
      return {
        ...state,
        isLoadingPaymentMethods: true,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHOD_UPDATE_SUCCESS:
      return {
        ...state,
        paymentMethods: (state.paymentMethods || []).map(method =>
          method.id === action.paymentMethod.id ? action.paymentMethod : method,
        ),
        isLoadingPaymentMethods: false,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHOD_UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoadingPaymentMethods: false,
      };

    case adminPaymentGatewaysConstants.PAYMENT_METHOD_DELETE_REQUEST:
      return {
        ...state,
        isLoadingPaymentMethods: true,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHOD_DELETE_SUCCESS:
      return {
        ...state,
        paymentMethods: state.paymentMethods.filter(method => method.id !== action.id),
        isLoadingPaymentMethods: false,
      };
    case adminPaymentGatewaysConstants.PAYMENT_METHOD_DELETE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoadingPaymentMethods: false,
      };

    case adminPaymentGatewaysConstants.CHARGE_STATUS_FETCH_REQUEST:
      return {
        ...state,
        isLoadingChargeStatus: true,
      };
    case adminPaymentGatewaysConstants.CHARGE_STATUS_FETCH_SUCCESS:
      return {
        ...state,
        chargeStatus: action.payload.chargeStatus,
        isLoadingChargeStatus: false,
      };
    case adminPaymentGatewaysConstants.CHARGE_STATUS_FETCH_FAILURE:
      return {
        ...state,
        isLoadingChargeStatus: false,
        error: action.payload.error,
      };

    case adminPaymentGatewaysConstants.CHARGE_STATUS_CREATE_REQUEST:
      return {
        ...state,
        isLoadingChargeStatus: true,
      };
    case adminPaymentGatewaysConstants.CHARGE_STATUS_CREATE_SUCCESS:
      return {
        ...state,
        chargeStatus: [...state.chargeStatus, action.payload.chargeStatus],
        isLoadingChargeStatus: false,
      };
    case adminPaymentGatewaysConstants.CHARGE_STATUS_CREATE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoadingChargeStatus: false,
      };

    case adminPaymentGatewaysConstants.CHARGE_STATUS_UPDATE_REQUEST:
      return {
        ...state,
        isLoadingChargeStatus: true,
      };
    case adminPaymentGatewaysConstants.CHARGE_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        chargeStatus: state.chargeStatus.map(cs =>
          cs.id === action.payload.chargeStatus.id ? action.payload.chargeStatus : cs,
        ),
        isLoadingChargeStatus: false,
      };
    case adminPaymentGatewaysConstants.CHARGE_STATUS_UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoadingChargeStatus: false,
      };

    case adminPaymentGatewaysConstants.CHARGE_STATUS_DELETE_REQUEST:
      return {
        ...state,
        isLoadingChargeStatus: true,
      };
    case adminPaymentGatewaysConstants.CHARGE_STATUS_DELETE_SUCCESS:
      return {
        ...state,
        chargeStatus: state.chargeStatus.filter(cs => cs.id !== action.payload.id),
        isLoadingChargeStatus: false,
      };
    case adminPaymentGatewaysConstants.CHARGE_STATUS_DELETE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoadingChargeStatus: false,
      };

    case adminPaymentGatewaysConstants.CHARGE_STATUS_GATEWAY_FETCH_REQUEST:
      return {
        ...state,
        isLoadingChargeStatusPaymentGateways: true,
      };
    case adminPaymentGatewaysConstants.CHARGE_STATUS_GATEWAY_FETCH_SUCCESS:
      return {
        ...state,
        chargeStatusPaymentGateways: action.payload.chargeStatusGateways,
        isLoadingChargeStatusPaymentGateways: false,
      };
    case adminPaymentGatewaysConstants.CHARGE_STATUS_GATEWAY_FETCH_FAILURE:
      return {
        ...state,
        isLoadingChargeStatusPaymentGateways: false,
        error: action.error,
      };

    case adminPaymentGatewaysConstants.CHARGE_STATUS_GATEWAY_CREATE_REQUEST:
      return {
        ...state,
        isLoadingChargeStatusPaymentGateways: true,
      };
    case adminPaymentGatewaysConstants.CHARGE_STATUS_GATEWAY_CREATE_SUCCESS:
      return {
        ...state,
        isLoadingChargeStatusPaymentGateways: false,
      };
    case adminPaymentGatewaysConstants.CHARGE_STATUS_GATEWAY_CREATE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoadingChargeStatusPaymentGateways: false,
      };

    case adminPaymentGatewaysConstants.CHARGE_STATUS_GATEWAY_UPDATE_REQUEST:
      return {
        ...state,
        isLoadingChargeStatusPaymentGateways: true,
      };
    case adminPaymentGatewaysConstants.CHARGE_STATUS_GATEWAY_UPDATE_SUCCESS:
      return {
        ...state,
        isLoadingChargeStatusPaymentGateways: false,
      };
    case adminPaymentGatewaysConstants.CHARGE_STATUS_GATEWAY_UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoadingChargeStatusPaymentGateways: false,
      };

    case adminPaymentGatewaysConstants.CHARGE_STATUS_GATEWAY_DELETE_REQUEST:
      return {
        ...state,
        isLoadingChargeStatusPaymentGateways: true,
      };
    case adminPaymentGatewaysConstants.CHARGE_STATUS_GATEWAY_DELETE_SUCCESS:
      return {
        ...state,
        chargeStatusPaymentGateways: state.chargeStatusPaymentGateways.filter(
          association => association.id !== action.payload.id,
        ),
        isLoadingChargeStatusPaymentGateways: false,
      };
    case adminPaymentGatewaysConstants.CHARGE_STATUS_GATEWAY_DELETE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoadingChargeStatusPaymentGateways: false,
      };

    default:
      return state;
  }
}
